import { StyleSheet, View } from 'react-native';

import { BodyText, theme, VStack } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsIngredientHighlights = (props: Props) => {
  const { highlights } = props;

  return (
    <VStack gap={theme.spacing['2']}>
      {highlights.map((highlight) => (
        <View key={highlight} style={styles.highlightContainer}>
          <BodyText sizeMatch={['12']} maxFontSizeMultiplier={1.2} style={styles.highlightText}>
            {highlight}
          </BodyText>
        </View>
      ))}
    </VStack>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  highlightContainer: {
    alignSelf: 'flex-start',
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
    borderRadius: theme.radius.xlarge,
    paddingVertical: theme.spacing['1'],
    paddingHorizontal: theme.spacing['2'],
  },
  highlightText: {
    color: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  highlights: string[];
};
